/* Yuropet® icon fallback: convert diagonal arrows in interactive content into
 * monochrome SVG. Does not alter standard horizontal arrows or page prose. */
(() => {
  const ns='http://www.w3.org/2000/svg';
  const diagonal=/[↗↖↘↙⬈⬉⬊⬋]/u;
  const pieces=/([↗↖↘↙⬈⬉⬊⬋][\uFE0E\uFE0F]?)/u;
  const angle={'↗':0,'⬈':0,'↖':270,'⬉':270,'↘':90,'⬊':90,'↙':180,'⬋':180};
  function icon(char){
    const svg=document.createElementNS(ns,'svg');
    svg.setAttribute('viewBox','0 0 20 20');
    svg.setAttribute('width','17');
    svg.setAttribute('height','17');
    svg.setAttribute('fill','none');
    svg.setAttribute('stroke','currentColor');
    svg.setAttribute('stroke-width','1.65');
    svg.setAttribute('stroke-linecap','round');
    svg.setAttribute('stroke-linejoin','round');
    svg.setAttribute('aria-hidden','true');
    svg.setAttribute('focusable','false');
    svg.style.cssText='display:inline-block;vertical-align:-.13em;width:1.05em;height:1.05em;flex:none';
    for(const path of ['M4.6 15.4 15 5','M6.8 5H15v8.2']){
      const el=document.createElementNS(ns,'path');
      el.setAttribute('d',path);
      svg.appendChild(el);
    }
    if(angle[char])svg.style.transform='rotate('+angle[char]+'deg)';
    return svg;
  }
  function normalize(root){
    if(!root || typeof root.querySelectorAll!=='function')return;
    for(const element of root.querySelectorAll('a,button,[role="button"]')){
      if(!diagonal.test(element.textContent||''))continue;
      const walker=document.createTreeWalker(element,NodeFilter.SHOW_TEXT);
      const targets=[];
      while(walker.nextNode()){
        const node=walker.currentNode;
        if(diagonal.test(node.nodeValue||''))targets.push(node);
      }
      for(const node of targets){
        const fragments=(node.nodeValue||'').split(pieces);
        const fragment=document.createDocumentFragment();
        for(const part of fragments){
          const ch=part.charAt(0);
          if(Object.prototype.hasOwnProperty.call(angle,ch))fragment.appendChild(icon(ch));
          else if(part)fragment.appendChild(document.createTextNode(part));
        }
        node.replaceWith(fragment);
      }
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>normalize(document),{once:true});
  else normalize(document);
  document.addEventListener('shopify:section:load',(event)=>normalize(event.target));
  window.addEventListener('pageshow',(event)=>{if(event.persisted)normalize(document)});
})();